"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayOfWeek = exports.Frequency = exports.PeriodType = exports.EndOfMonthConvention = exports.DateMovingConvention = exports.HolidayOutput = void 0;
var HolidayOutput;
(function (HolidayOutput) {
    HolidayOutput["Date"] = "Date";
    HolidayOutput["Names"] = "Names";
    HolidayOutput["Calendars"] = "Calendars";
    HolidayOutput["Countries"] = "Countries";
})(HolidayOutput || (exports.HolidayOutput = HolidayOutput = {}));
var DateMovingConvention;
(function (DateMovingConvention) {
    DateMovingConvention["NoMoving"] = "NoMoving";
    DateMovingConvention["PreviousBusinessDay"] = "PreviousBusinessDay";
    DateMovingConvention["NextBusinessDay"] = "NextBusinessDay";
    DateMovingConvention["ModifiedFollowing"] = "ModifiedFollowing";
    DateMovingConvention["BbswModifiedFollowing"] = "BbswModifiedFollowing";
    DateMovingConvention["EveryThirdWednesday"] = "EveryThirdWednesday";
})(DateMovingConvention || (exports.DateMovingConvention = DateMovingConvention = {}));
var EndOfMonthConvention;
(function (EndOfMonthConvention) {
    EndOfMonthConvention["Last"] = "Last";
    EndOfMonthConvention["Same"] = "Same";
    EndOfMonthConvention["Last28"] = "Last28";
    EndOfMonthConvention["Same28"] = "Same28";
})(EndOfMonthConvention || (exports.EndOfMonthConvention = EndOfMonthConvention = {}));
var PeriodType;
(function (PeriodType) {
    PeriodType["Day"] = "Day";
    PeriodType["Year"] = "Year";
    PeriodType["WorkingDay"] = "WorkingDay";
    PeriodType["NonWorkingDay"] = "NonWorkingDay";
    PeriodType["NearestTenor"] = "NearestTenor";
})(PeriodType || (exports.PeriodType = PeriodType = {}));
var Frequency;
(function (Frequency) {
    Frequency["Daily"] = "Daily";
    Frequency["Weekly"] = "Weekly";
    Frequency["BiWeekly"] = "BiWeekly";
    Frequency["Monthly"] = "Monthly";
    Frequency["Yearly"] = "Yearly";
})(Frequency || (exports.Frequency = Frequency = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Sunday"] = "Sunday";
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));
